export const styles = {
  container: {
    paddingRight: "5%",
    paddingLeft: "5%",
  },
};
